<template>
  <div class="privacy">
    <div class="main-content">
      <h2>PRIVACY POLICY</h2>
      <p class="border">Smiling Home</p>
<p>

      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "contact",
  data(){
  },
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/privacy.less";
</style>



// WEBPACK FOOTER //
// src/view/privacy.vue